var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoticiasYEventos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_34_2",
    "data-name": "Componente 34 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-bullhorn",
    "data-name": "Icon awesome-bullhorn",
    d: "M20,8.333a2.212,2.212,0,0,0-1.111-1.914V1.111A1.122,1.122,0,0,0,17.778,0a1.109,1.109,0,0,0-.694.244L14.132,2.606A8.428,8.428,0,0,1,8.889,4.444H2.222A2.222,2.222,0,0,0,0,6.667V10a2.222,2.222,0,0,0,2.222,2.222h1.17a8.438,8.438,0,0,0-.076,1.111A8.8,8.8,0,0,0,4.2,17.185a1.09,1.09,0,0,0,.986.592H7.769a1.1,1.1,0,0,0,.9-1.756,4.422,4.422,0,0,1-.908-2.689,4.2,4.2,0,0,1,.153-1.111h.975a8.426,8.426,0,0,1,5.242,1.839l2.952,2.362a1.111,1.111,0,0,0,1.8-.867V10.248A2.213,2.213,0,0,0,20,8.333Zm-3.333,4.91-1.148-.918A10.653,10.653,0,0,0,8.889,10V6.667a10.653,10.653,0,0,0,6.63-2.326l1.148-.918Z",
    transform: "translate(0 1)",
    fill: "#47476b"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_148138",
    "data-name": "Rect\\xE1ngulo 148138",
    width: 20,
    height: 20,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticiasYEventos);
export default __webpack_public_path__ + "static/media/noticias-y-eventos.fa05611f1e7b3374e2174456bbb89562.svg";
export { ForwardRef as ReactComponent };